import React from 'react';
// @ts-ignore
import logoImage from '../tbl_logo.png';

const Footer: React.FC = () => {
    return (
        <footer className="app-global-footer">
            <div className="footer-content">
                <p className="developed-by">Developed & Anchored by</p>
                <a
                    href="https://www.tblservices.in/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="footer-logo-link"
                >
                    <img src={logoImage} alt="TBL Logo" className="footer-logo" />
                </a>
            </div>
        </footer>
    );
};

export default Footer;
